import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { PlatformContext } from "./PlatformContext";
interface PlatformProviderProps {
  children: React.ReactNode;
}

const PlattformProvider: React.FC<PlatformProviderProps> = ({ children }) => {
  const [isDesktop, setDesktop] = useState(
    useMediaQuery({ query: "(min-width: 768px)" })
  );
  return (
    <PlatformContext.Provider value={{ isDesktop, setDesktop }}>
      {children}
    </PlatformContext.Provider>
  );
};

export default PlattformProvider;
